/* istanbul ignore file */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkyHeaderComponent } from './sky-header/sky-header.component';
import { RouterModule } from '@angular/router';
import { SkyBoxDetailsComponent } from './sky-box-details/sky-box-details.component';

@NgModule({
  declarations: [SkyHeaderComponent, SkyBoxDetailsComponent],
  exports: [SkyHeaderComponent, SkyBoxDetailsComponent],
  imports: [CommonModule, RouterModule],
})
export class SharedSkyComponentsModule {}
